import useEmblaCarousel from "embla-carousel-react";
import { memo, useCallback, useEffect, useRef, useState } from "react";
import { EmblaCarouselType } from 'embla-carousel';
import { Button } from "../ui/button";
import { RadioGroup, RadioGroupItem } from "../ui/radio-group";
import styles from "./examples-of-questions.module.css";
import Question1 from "@/assets/images/question-1.png";
import Question2 from "@/assets/images/question-2.png";
import Question4 from "@/assets/images/question-4.png";
import Question6 from "@/assets/images/question-6.png";
import Question7 from "@/assets/images/question-7.jpg";
import SliderBoy from "@/assets/images/about_slider-boy.png";

const ExamplesOfQuestionsSlider = memo(function getExamplesOfQuestionsSlider() {
    const [emblaRef, emblaApi] = useEmblaCarousel({containScroll: false});
    const [selectedIndex, setSelectedIndex] = useState(0);
    const [scrollSnaps, setScrollSnaps] = useState<number[]>([]);
    const [isAllQuestionsCorrect, setIsAllQuestionsCorrect] = useState<boolean>(false);

    const onDotButtonClick = useCallback((index: number) => {
        if (!emblaApi) return
        emblaApi.scrollTo(index)
    },[emblaApi]);
    
    const onInit = useCallback((emblaApi: EmblaCarouselType) => {
        setScrollSnaps(emblaApi.scrollSnapList())
    }, []);
    
    const onSelect = useCallback((emblaApi: EmblaCarouselType) => {
        setSelectedIndex(emblaApi.selectedScrollSnap())
    }, []);
    
    useEffect(() => {
        if (!emblaApi) return
    
        onInit(emblaApi)
        onSelect(emblaApi)
        emblaApi.on('reInit', onInit).on('reInit', onSelect).on('select', onSelect)
    }, [emblaApi, onInit, onSelect]);

    const [question1, setQuestion1] = useState<null | number>(null);
    const [question2, setQuestion2] = useState<null | number>(null);
    const [question3, setQuestion3] = useState<null | number>(null);
    const [question4, setQuestion4] = useState<null | number>(null);
    const [question5, setQuestion5] = useState<null | number>(null);
    const [question6, setQuestion6] = useState<null | number>(null);
    const [question7, setQuestion7] = useState<null | number>(null);

    const checkAnswer = (question: Question, value: number, index: number) => {
        question.answerSetter(value);

        const answerBlock = document.getElementById(`${question.name}_${value}`);
        if (!answerBlock) return;

        const answersItems = document.getElementById(question.name)?.getElementsByClassName('answer');
        if (answersItems?.length) {
            Array.from(answersItems).forEach((answerBlock) => {
                answerBlock.classList.remove('success', 'error')
            });
        }

        if (question.answer === value) {
            answerBlock.classList.add('success');
            question.success = true;

            if (questions.every((questionEvery) => questionEvery.success === true)) {
                setIsAllQuestionsCorrect(true);
                setTimeout(() => {
                    onDotButtonClick(questions.length + 1);
                }, 300);
            } else {
                onDotButtonClick(index+1);
            }
        } else {
            answerBlock.classList.add('error');
            question.success = false;
        }
    }

    interface Question {
        name: string,
        title: string,
        variants: string[],
        answer: number,
        img?: string,
        answerSetter: React.Dispatch<React.SetStateAction<number | null>>,
        success: boolean,
    }

    const questions: Question[] = [
        {
            name: "question1",
            title: "Кто упоминается в названии этой картины?",
            variants: [
                "Пловцы", "Гребцы", "Моряки", "Капитаны"
            ],
            answer: 2,
            img: Question1,
            answerSetter: setQuestion1,
            success: false
        },
        {
            name: "question2",
            title: "Скриншот из какой игры перед вами?",
            variants: [
                "Atomic Heart", "Смута", "Hogwarts Legacy", "Cyberpunk 2077"
            ],
            answer: 1,
            img: Question2,
            answerSetter: setQuestion2,
            success: false
        },
        {
            name: "question3",
            title: "Дословный перевод названия этой настольной игры — «рыться в поисках чего-либо». Назовите эту игру.",
            variants: [
                "Alias", "Scrabble", "Carcassonne", "Hive"
            ],
            answer: 2,
            answerSetter: setQuestion3,
            success: false
        },
        {
            name: "question4",
            title: "Перед вами фото актрис, сыгравших главные роли в фильме 2024 года выхода. Каком?",
            variants: [
                "Субстанция", "Содержимое", "Материя", "Вещество"
            ],
            answer: 1,
            img: Question4,
            answerSetter: setQuestion4,
            success: false
        },
        {
            name: "question5",
            title: "Буквы какого цвета используются в логотипе торговой марки Chupa Chups?",
            variants: [
                "Синего", "Белого", "Жёлтого", "Красного"
            ],
            answer: 4,
            answerSetter: setQuestion5,
            success: false
        },
        {
            name: "question6",
            title: "Как зовут этого персонажа?",
            variants: [
                "Илья Муромец", "Добрыня Никитич", "Алёша Попович", "Купец Колыван"
            ],
            answer: 1,
            img: Question6,
            answerSetter: setQuestion6,
            success: false
        },
        {
            name: "question7",
            title: "Кто из них не комиссар?",
            variants: [
                "", "", "", ""
            ],
            answer: 3,
            img: Question7,
            answerSetter: setQuestion7,
            success: false
        },
    ];

    return (
        <div className={styles.embla}>
            <div className={styles.viewport} ref={emblaRef}>
                <div className={styles.container}>
                    {questions.map((question, index) => {
                        return (
                            <div key={index} className={styles.slideContainer}>
                                <div 
                                    className={styles.slide}
                                    style={{
                                        background: ` linear-gradient(180deg,transparent 0%, transparent 10%, rgba(28, 9, 37, 1) 100%),center / cover no-repeat url(${question.img})`,                   
                                    }}
                                >
                                    <div className=" h-full flex flex-col justify-end items-center">
                                        <p className="pt-4 text-xl sm:text-3xl font-bold max-w-[650px] mb-2 sm:mb-8 ">
                                            {question.title}
                                        </p>
                                        <RadioGroup 
                                            className="[&_.answer.success]:bg-[#3BC6B2] [&_.answer.error]:bg-[#F60852] [&_.answer]:gap-4 [&_.answer]:flex [&_.answer]:items-center [&_.answer]:front-bold grid grid-cols-1 sm:grid-cols-2 w-full gap-2"
                                            onValueChange={(value) => checkAnswer(question, Number(value), index)}
                                            id={question.name}
                                        >
                                            {question.variants.map((variant, index) => {
                                                return (
                                                    <div key={index} className="answer w-full bg-[#30133F] p-4 rounded-md transition-all duration-300" id={`${question.name}_${index+1}`}>
                                                        <RadioGroupItem value={String(index+1)} className="w-6 h-6"/>
                                                        <label><strong>{index+1}.</strong> {variant} </label>                                             
                                                    </div>
                                                );
                                            })}
                                        </RadioGroup>
                                    </div>
                                </div>
                            </div>
                        )
                    })}
                    {isAllQuestionsCorrect && (
                        <div className={styles.slideContainer + ' transition-all duration-300'}>
                            <div 
                                className={styles.slide + ' flex justify-center flex-col 2xl:flex-row 2xl:pl-12 items-center'}
                                style={{
                                    background: 'radial-gradient(at right center, rgba(255, 219, 18, 0.2),transparent)'
                                }}  
                            >
                                <div className="flex flex-col justify-center max-w-[560px]">
                                    <h3 className="text-3xl sm:text-5xl font-bold pb-4">Хорошая работа!</h3>
                                    <p className="pb-8">Разминка пройдена. Время сыграть по-настоящему. Больше вопросов, больше азарта!</p>
                                    <Button className="sm:text-2xl w-full sm:w-auto py-6 px-16"  onClick={() => document.querySelector('#games')?.scrollIntoView({ behavior: 'smooth' })}>
                                        Выбрать игру
                                    </Button>  
                                </div>
                                <div className="max-w-[300px] 2xl:max-w-[700px]">
                                    <img className={styles.imgReflection} src={SliderBoy} />    
                                </div>
                                
                            </div>
                        </div>
                    )}
                </div>
            </div>
    
            <div className={styles.dots}>
                {scrollSnaps.map((_, index) => (
                    <div 
                        key={index} 
                        className={(index === selectedIndex ? styles.dotSelected + " " : " ") + styles.dot}
                        onClick={() => onDotButtonClick(index)}
                    ></div>
                ))}
            </div>                
        </div>
    );
});

export {ExamplesOfQuestionsSlider};